import { useEffect, useState } from 'react';
import { useScrollTo } from '../lib/motion';
import { SECTIONS } from './Nav';
import './Foot.css';

const SOCIALS = [
  { l: 'GitHub',    h: 'https://github.com/rarespoanta27' },
  { l: 'LinkedIn',  h: 'https://www.linkedin.com/in/rares-poanta-b3970b309' },
  { l: 'Instagram', h: 'https://www.instagram.com/rares.poanta/' },
  { l: 'Email',     h: 'mailto:rarespoanta10@gmail.com' },
];

export default function Foot() {
  const scrollTo = useScrollTo();
  const [clock, setClock] = useState('');

  useEffect(() => {
    const fmt = () =>
      new Intl.DateTimeFormat('en-GB', {
        hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/Bucharest',
      }).format(new Date());
    setClock(fmt());
    const id = setInterval(() => setClock(fmt()), 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer className="ft" role="contentinfo">
      <div className="shell">

        <div className="ft-top">
          <div className="ft-brand">
            <button className="ft-back" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="19" x2="12" y2="5" /><polyline points="6 11 12 5 18 11" />
              </svg>
              Back to top
            </button>
            <p className="ft-tagline">
              Full-stack engineering, product architecture and cloud infrastructure —
              delivered by one person who stays accountable for the whole system.
            </p>
            <div className="ft-status">
              <span className="avail"><i className="avail-led" />Open for new projects</span>
              <span className="mono ft-clock">Timișoara · {clock}</span>
            </div>
          </div>

          <nav className="ft-nav" aria-label="Footer">
            <span className="mono ft-col-label">Index</span>
            <ul>
              {SECTIONS.map((s) => (
                <li key={s.id}>
                  <button onClick={() => scrollTo(s.id)}>
                    <i>{s.idx}</i>{s.label}
                  </button>
                </li>
              ))}
              <li>
                <button onClick={() => scrollTo('contact')}><i>07</i>Contact</button>
              </li>
            </ul>
          </nav>

          <div className="ft-links">
            <span className="mono ft-col-label">Elsewhere</span>
            <ul>
              {SOCIALS.map((s) => (
                <li key={s.l}>
                  <a
                    href={s.h}
                    target={s.h.startsWith('mailto') ? undefined : '_blank'}
                    rel={s.h.startsWith('mailto') ? undefined : 'noopener noreferrer me'}
                  >
                    {s.l}
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="7" y1="17" x2="17" y2="7" /><polyline points="7 7 17 7 17 17" />
                    </svg>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="ft-wordmark" aria-hidden="true" data-rv="clip">
          POANTA RAREȘ
        </div>

        <div className="ft-bottom">
          <span className="mono">© {new Date().getFullYear()} AlgorX Software SRL</span>
          <span className="mono">Built in React · deployed on Vercel</span>
        </div>
      </div>
    </footer>
  );
}
